import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, filter, switchMap, take } from 'rxjs';
import { TokenService } from '@processo/services/token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // The /fetchtokens request itself must bypass the gate; otherwise the
    // refresh would deadlock waiting for itself to finish.
    if (req.url.includes('/eru/fetchtokens')) {
      return next.handle(this.attachTokens(req));
    }

    return this.tokenService.refreshInProgress$.pipe(
      filter((inProgress) => !inProgress),
      take(1),
      switchMap(() => next.handle(this.attachTokens(req))),
    );
  }

  private attachTokens(req: HttpRequest<unknown>): HttpRequest<unknown> {
    const idToken = this.tokenService.getIdToken();
    const access_token = this.tokenService.getAccessToken();
    if (idToken && access_token) {
      return req.clone({
        setHeaders: {
          Authorization: `${access_token}`,
          id_token: `${idToken}`,
        },
      });
    }
    return req;
  }
}

